import React, { useState } from "react";
import { X } from "lucide-react";
import { IconButton } from "../ui";

/**
 * QA builds only (`npm run build:qa` sets REACT_APP_QA_OTP): a corner note with
 * the one OTP every QA flow accepts and a link to the QA inbox, where QA's
 * email and SMS land. A production build has no REACT_APP_QA_OTP, so this
 * renders nothing and its text is not even in the bundle's output.
 */
const HIDE_KEY = "vc-qa-notice-hidden";

const readHidden = () => {
  try {
    return window.sessionStorage.getItem(HIDE_KEY) === "1";
  } catch {
    return false;
  }
};

export default function QaNotice() {
  const [hidden, setHidden] = useState(readHidden);
  const QA_OTP = process.env.REACT_APP_QA_OTP || "";
  const QA_MAILBOX = process.env.REACT_APP_QA_MAILBOX || "";
  if (!QA_OTP || hidden) return null;

  const hide = () => {
    try { window.sessionStorage.setItem(HIDE_KEY, "1"); } catch { /* storage blocked — hide for this page only */ }
    setHidden(true);
  };

  return (
    <div role="note" className="no-print tw-fixed tw-bottom-3 tw-left-3 tw-z-toast tw-flex tw-items-center tw-gap-2 tw-rounded-lg tw-border tw-border-warning tw-bg-warning-soft tw-py-1 tw-pl-3 tw-pr-1 tw-shadow-md">
      <span className="tw-text-xs tw-text-warning-fg">
        <strong>QA</strong> · every OTP is <strong>{QA_OTP}</strong>
        {QA_MAILBOX && (
          <>
            {" "}· mail &amp; SMS:{" "}
            <a href={QA_MAILBOX} target="_blank" rel="noreferrer" className="tw-font-semibold tw-text-warning-fg tw-underline">
              QA inbox
            </a>
          </>
        )}
      </span>
      <IconButton label="Hide the QA note" icon={X} size="xs" onClick={hide} />
    </div>
  );
}
